module.exports = __webpack_public_path__ + "img/back.cbbb187d.svg";